import fallbackBlogData from '../data/blogs.json';

const toDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
};

export const slugify = (value = '') => value
  .toString()
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '') || 'blog-entry';

export const shapeTopic = (topic = {}) => ({
  id: topic.id,
  name: topic.name || '',
  slug: (topic.slug || '').toLowerCase(),
  description: topic.description || '',
  sortOrder: typeof topic.sortOrder === 'number' ? topic.sortOrder : 0
});

export const shapeBlog = (item = {}) => {
  const topics = Array.isArray(item.topics) ? item.topics.map(shapeTopic) : [];
  const topicIdsFromTopics = topics.map((topic) => topic.id).filter((id) => Number.isInteger(id));
  return {
    id: item.id,
    slug: (item.slug || slugify(item.title || item.id)).toLowerCase(),
    title: item.title || '',
    category: item.category || '',
    excerpt: item.excerpt || '',
    content: item.content || '',
    author: item.author || '',
    date: toDate(item.date) || new Date().toISOString(),
    readTime: item.readTime || '',
    image: item.image || '',
    htmlTitle: item.htmlTitle || '',
    htmlMetaTags: item.htmlMetaTags || '',
    tags: Array.isArray(item.tags) ? item.tags : [],
    topics,
    topicIds: Array.isArray(item.topicIds) && item.topicIds.length ? item.topicIds : topicIdsFromTopics
  };
};

export const fallbackBlogs = (fallbackBlogData.blogs || []).map(shapeBlog);

const isSameBlog = (blog, key) => {
  if (!blog || key == null) return false;
  const normalized = typeof key === 'string' ? key.trim().toLowerCase() : key;
  return blog.id === key || blog.slug === normalized;
};

export const getRecentBlogs = (blogs, excludeKey, count = 4) => {
  const sorted = [...(blogs || [])].sort((a, b) => new Date(b.date) - new Date(a.date));
  return sorted.filter((blog) => !isSameBlog(blog, excludeKey)).slice(0, count);
};

export const getSimilarBlogs = (blogs, currentBlog, count = 3) => {
  if (!currentBlog) return [];
  const topicSlugs = new Set((currentBlog.topics || []).map((topic) => topic.slug));
  if (!topicSlugs.size) {
    return getRecentBlogs(blogs, currentBlog?.slug || currentBlog?.id, count);
  }
  const sorted = [...(blogs || [])].sort((a, b) => new Date(b.date) - new Date(a.date));
  const similar = sorted.filter((blog) => {
    if (isSameBlog(blog, currentBlog.slug || currentBlog.id)) return false;
    return (blog.topics || []).some((topic) => topicSlugs.has(topic.slug));
  });
  if (similar.length >= count) {
    return similar.slice(0, count);
  }
  const filler = getRecentBlogs(blogs, currentBlog.slug || currentBlog.id, count * 2);
  const ids = new Set(similar.map((blog) => blog.id));
  filler.forEach((blog) => {
    if (similar.length < count && !ids.has(blog.id)) {
      similar.push(blog);
      ids.add(blog.id);
    }
  });
  return similar.slice(0, count);
};

export const deriveTopicsFromBlogs = (blogs) => {
  const map = new Map();
  (blogs || []).forEach((blog) => {
    (blog.topics || []).forEach((topic) => {
      if (!topic || !topic.slug) return;
      if (!map.has(topic.slug)) {
        map.set(topic.slug, topic);
      }
    });
  });
  return Array.from(map.values()).sort((a, b) => a.sortOrder - b.sortOrder || a.name.localeCompare(b.name));
};
